module.exports = __webpack_public_path__ + "img/Jaji-log.3811b334.png";